"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserLoginRequiredResponseMapper = void 0;
var UserLoginRequiredResponseMapper = /** @class */ (function () {
    function UserLoginRequiredResponseMapper(data) {
        this.localData = data;
    }
    UserLoginRequiredResponseMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return UserLoginRequiredResponseMapper;
}());
exports.UserLoginRequiredResponseMapper = UserLoginRequiredResponseMapper;
//# sourceMappingURL=UserLoginRequiredResponseMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/models/mappers/UserLoginRequiredResponseMapper.js
// module id = 2218
// module chunks = 8